import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext, useLocation } from "react-router-dom";

export function useNavigationBlocker(shouldBlock, options = {}) {
  const { onBlock, debounceMs = 100 } = options;

  const { navigator } = useContext(UNSAFE_NavigationContext);
  const location = useLocation();

  useEffect(() => {
    if (!shouldBlock) return;

    const push = navigator.push;
    const replace = navigator.replace;
    let blocked = false;

    navigator.push = (...args) => {
      if (shouldBlock && !blocked) {
        blocked = true;
        onBlock?.();
        setTimeout(() => {
          blocked = false;
        }, debounceMs);
        return;
      }
      return push.apply(navigator, args);
    };

    navigator.replace = (...args) => {
      if (shouldBlock && !blocked) {
        blocked = true;
        onBlock?.();
        setTimeout(() => {
          blocked = false;
        }, debounceMs);
        return;
      }
      return replace.apply(navigator, args);
    };

    return () => {
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [shouldBlock, onBlock, navigator, location, debounceMs]);

  // Block browser/tab close
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (shouldBlock) {
        e.preventDefault();
        e.returnValue = "";
        return e.returnValue;
      }
    };

    if (shouldBlock) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldBlock]);
}
